module.exports = __webpack_public_path__ + "img/straight-rail-horizontal-ties-remnants.70000310.png";